
<template>
  <div class="root">
      <!-- <div class="top-box">
        <div class="top-box-left">
            <div class="title-view">
                <i class="el-icon-guide" style="color:#39bf3e;" />
                <div class="title">新手指南</div>
            </div>
            <div class="row-view">
                <div class="row1">注册账户</div>
                <div class="row2">平台功能</div>
                <div class="row3">买家保障</div>
            </div>
        </div>
        <div class="top-box-mid">
            <div class="title-view">
                <i class="el-icon-service" style="color:#39bf3e;" />
                <div class="title">产品服务</div>
            </div>
            <div class="row-view">
                <div class="row1">找供应</div>
                <div class="row2">找采购</div>
                <div class="row3">看行情</div>
                 <div class="row3">发布供应</div>
            </div>
        </div>
        <div class="top-box-right">
            <div class="title-view">
                <i class="el-icon-chat-dot-square" style="color:#39bf3e;" />
                <div class="title">合作联系</div>
            </div>
            <div class="row-view">
                <div class="row1">客户服务 400-000-0000</div>
                <div class="row2">商务洽谈 XXX-XXX-XXXX</div>
                <div class="row3">媒体合作 XXX-XXX-XXXX</div>
            </div>
        </div>
      </div> -->
      <div class="bottom-box">
        <div class="link-items">友情链接：</div>
        <a href="https://news.cnhnb.com/s/" target="_blank" class="link-items" data-v-413e6b15="">农产品搜索</a>
        <a href="https://www.putaojiu.com" target="_blank" class="link-items" data-v-413e6b15="">葡萄酒</a>
        <a href="http://www.kumifeng.com/" target="_blank" class="link-items" data-v-413e6b15="">蜜蜂网</a>
        <a href="https://www.qmxip.com/" target="_blank" class="link-items" data-v-413e6b15="">商标查询</a>
        <a href="https://www.tnc.com.cn/" target="_blank" class="link-items" data-v-413e6b15="">全球纺织网</a>
        <a href="https://www.guanmai.cn " target="_blank" class="link-items" data-v-413e6b15="">生鲜配送系统</a>
        <a href="https://www.qichamao.com/" target="_blank" class="link-items" data-v-413e6b15="">企业查询</a>
        <a href="https://www.loupan.com" target="_blank" class="link-items" data-v-413e6b15="">楼盘网</a>
        <a href="https://www.cnmo.com" target="_blank" class="link-items" data-v-413e6b15="">科技新闻</a>
        <a href="https://www.chashebao.com " target="_blank" class="link-items" data-v-413e6b15="">社保查询网</a>
        <a href="https://www.nonggan.com/" target="_blank" class="link-items" data-v-413e6b15="">农敢网</a>
        <a href="https://www.familydoctor.com.cn/" target="_blank" class="link-items" data-v-413e6b15=""> 家庭医生</a>
        <a href="https://www.zhipin.com/" target="_blank" class="link-items" data-v-413e6b15="">招聘</a>
        <a href="https://www.hbzhan.com/" target="_blank" class="link-items" data-v-413e6b15="">环保</a>
        <a href="http://www.qizuang.com" target="_blank" class="link-items" data-v-413e6b15="">装修公司</a>
        <a href="http://www.huangye88.com/" target="_blank" class="link-items" data-v-413e6b15="">B2B电子商务</a>
        <a href="http://www.bidchance.com/" target="_blank" class="link-items" data-v-413e6b15="">中国招标网</a>
        <a href="http://www.okaoyan.com/" target="_blank" class="link-items" data-v-413e6b15="">考研网</a>
        <a href="http://www.3456.tv/" target="_blank" class="link-items" data-v-413e6b15="">农资代理</a>
        <a href="https://www.puercn.com" target="_blank" class="link-items" data-v-413e6b15="">茶友网</a>
        <a href="https://www.21food.cn/" target="_blank" class="link-items" data-v-413e6b15="">食品商务网</a>
        <a href="https://www.huamu.com/" target="_blank" class="link-items" data-v-413e6b15="">中国花木网</a>
        <a href="https://www.ppxmw.com/" target="_blank" class="link-items" data-v-413e6b15="">中国畜牧网</a>
        <a href="https://www.tuliu.com/" target="_blank" class="link-items" data-v-413e6b15="">土地流转网</a>
      </div>
    <div class="beian">
        <a href="https://beian.miit.gov.cn//" target="_blank" class="link-items" data-v-413e6b15="">
            <img src="//files.cnhnb.com/master-ssr/home/img/10de317.png" alt="" class="wgn-icon" data-v-01aef543="">
            沪ICP备2023020346号 维萨银海（上海）技术有限公司</a>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  }
}
</script>
<style lang = "scss" scoped>
.root{
  width: 100%;
  height: 360px;
  padding: 15px 8vw;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  .top-box {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 260px;
    width: 100%;
    margin-bottom: 25px;
    padding: 20px;
    box-sizing: border-box;
    border: 1px solid #e9e9e9;
    .top-box-left,.top-box-mid,.top-box-right{
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0px 30px ;
        margin-left: 5%;
        margin-right: 5%;

        .title-view {
            display: flex;
            flex-direction: row;
            align-items: center;
            .title {
                margin-left: 18px;
                font-size: 18px;
                font-weight: 500;
            }
        }
        .row-view {
            display: flex;
            color:#646464;
            flex-direction: column;
            font-size: 12px;
            .row1,.row2,.row3{
                margin-top: 20px;
            }

        }
    }
  }
  .bottom-box {
    width: 100%;
    /* height: 70px; */
    background-color: #e9e9e9;
    display: flex;
    flex-wrap: wrap;
    padding: 10px 5px;
    box-sizing: border-box;
    .link-items{
        box-sizing: inherit;
        margin-top: 6px;
        margin-right: 10px;
        font-family: PingFangSC-Medium;
        font-size: 12px;
        color: #909090;
        letter-spacing: 0;
        &:not(div):hover {
            color: #127614;
        }
    }
  }
  .beian{
    height: 70px;
    background-color: #e9e9e9;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #909090;
    display: flex;
    align-items: center;
    .link-items{
        box-sizing: inherit;
        /* margin-top: 6px; */
        margin-left: 35%;
        font-family: PingFangSC-Medium;
        font-size: 12px;
        color: #909090;
        letter-spacing: 0;
        &:not(div):hover {
            color: #127614;
        }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/base/footerView.vue